module.exports = __webpack_public_path__ + "static/img/blank.ddbc4bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blank.png
// module id = bKGb
// module chunks = 0